/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { ExtractorCitrus } from "./modelExtractorCitrus";

class ControllerExtractorCitrus extends ControllerModel {
    constructor() {
        super("ControllerExtractorCitrus");

        this.setNewNode = (callback) => {
            let extractorcitrus = new ExtractorCitrus();
            extractorcitrus.decorate(callback);

            this.addNode(extractorcitrus);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let extractorcitrus = new ExtractorCitrus();
            extractorcitrus.copyFrom(node);
            extractorcitrus.decorate(callback);
            this.addNode(extractorcitrus)
        }

        this.getProperties = async (node) => {
            let n = new ExtractorCitrus();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new ExtractorCitrus();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerExtractorCitrus };